import React, { useState } from 'react'
import { Link } from 'react-router-dom';

import Navbar from '../../component/Navbar/navbar'
import Footer from '../../component/Footer/footer';

import "react-18-image-lightbox/style.css"

import { BsCheckCircle, MdKeyboardArrowRight } from '../../assets/icons/icons'
import { FaArrowRight } from '../../assets/icons/icons'

export default function IndexRestaurent() {
    let [isOpen, setOpen] = useState(false)
    let [activeIndex, setActiveIndex] = useState(0);
    let [isOpenTab, setisOpen] = useState(0);

    let handleTabClick = (index) => {
        setisOpen(index);
    };

    let toggleAccordion = (index) => {
        if (activeIndex === index) {
            setActiveIndex(0);
        } else {
            setActiveIndex(index);
        }
    }
    const [tab, setTab] = useState('Home');
    return (
        <>
            <Navbar navClass="nav-light" />

            <section className="flex md:h-screen py-36 items-center bg-[url('../../assets/images/food/bg01.jpg')] bg-no-repeat bg-fixed bg-top bg-cover">
                <div className="absolute inset-0 bg-black opacity-30"></div>
                <div className="container relative">
                    <div className="grid grid-cols-1 justify-center text-center">
                        <div className="">
                            <h1 className="font-bold lg:leading-normal leading-normal text-4xl lg:text-6xl text-white mb-5">CBSE Class 8 Syllabus</h1>
                            <p className="text-white/70 text-lg max-w-xl mx-auto">Tutormate  syllabus  CBSE Class 8 Syllabus</p>
                        </div>
                    </div>
                </div>
            </section>





            <div className="container relative mt-16">
                <h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold text-center">What you will learn</h3>
                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-16 gap-[30px]">
                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/phyIcon.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">Physics</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">Everything Physics – from force, pressure and sound to Electric current, Light and and the solar system – we’ve got you covered</p>
                            <Link to="/category" className='text-indigo-600 mt-3'>View full syllabus </Link>

                        </div>
                    </div>

                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/bioIcon.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">Biology</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">All the fundamentals of Biology along with energy conservation, crop management and production in this section</p>
                            <Link to="/category" className='text-indigo-600 mt-3'>View full syllabus </Link>


                        </div>
                    </div>

                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/chemIcon.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">Chemistry</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">Learn about contemporary issues such as pollution along with an in-depth study of natural resources along with their
uses</p>
                            <Link to="/category" className='text-indigo-600 mt-5'>View full syllabus </Link>

                        </div>
                    </div>

                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/mathIcon.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">Maths</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">An application oriented dive into roots, ratios and proportions and how they work in complex mathematicalsituations</p>
                            <Link to="/category" className='text-indigo-600 mt-5'>View full syllabus </Link>

                        </div>
                    </div>


                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/english.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">English</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">Increase your proficiency at reading comprehenssions, writing, grammar and vocabulary by upto ten fold with our interactive English section</p>
                            <Link to="/category" className='text-indigo-600 mt-5'>View full syllabus </Link>

                        </div>
                    </div>


                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/hisIcon.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">History</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">Get a comprehensive understading of your roots by studying about the British Raj in India and the Indian Independence struggle. Also gain a brief glimpse into the World’s history of art</p>
                            <Link to="/category" className='text-indigo-600 mt-5'>View full syllabus </Link>

                        </div>
                    </div>


                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/poltIcon.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">Political Science</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">The Indian Constitution, the Parliament, the functioning of the judicial system, and the concept of social justice – take a look into the fascinating world of Politics and Governance</p>
                            <Link to="/category" className='text-indigo-600 mt-5'>View full syllabus </Link>

                        </div>
                    </div>

                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/geogrIcon.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">Geography</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">Expand your boundaries by studying the various Geographies of the world and India and gain a deep understanding of the World and its inhabitants</p>
                            <Link to="/category" className='text-indigo-600 mt-5'>View full syllabus </Link>

                        </div>
                    </div>

                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                        <div
                            className="size-16   group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                            {/* <Icons className="size-6"/> */}
                            <img src='images/ecoIcon.jpg' className='width70'></img>
                        </div>

                        <div className="content mt-7">
                            <Link to="" className="title h5 text-lg font-medium hover:text-indigo-600">Economics</Link>
                            <p className="text-slate-400 mt-3 text-justify mb-5">Tap into your hidden Economist by learning about the basic principles of Economics and how it can be applied to nearly every facet of human life</p>
                            <Link to="/category" className='text-indigo-600 mt-5'>View full syllabus </Link>

                        </div>
                    </div>

                </div>
            </div>

            {<section className="relative py-16 mt-16 bg-gray-50 dark:bg-slate-800">
                <div className="container relative">
                    <div className="grid grid-cols-1 pb-8 text-center">
                        <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Features</h3>

                        {/* <p className="text-slate-400  mx-auto">Search your future opportunity with our categories</p> */}
                    </div>
                </div>

                <div className="container relative">
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
                        <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                            <div
                                className="size-16  group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                                {/* <Icons className="size-6"/> */}
                                <img src='images/unlimIcon.jpg' className='width70'></img>
                            </div>

                            <div className="content mt-7">
                                {/* <Link to="/page-services" className="title h5 text-lg font-medium hover:text-indigo-600">300+ hours of video content</Link> */}
                                <p className="text-slate-400 mt-3 text-justify mb-5">Unlimited access to all subjects</p>


                            </div>
                        </div>

                        <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                            <div
                                className="size-16  group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                                {/* <Icons className="size-6"/> */}
                                <img src='images/learnIcon.jpg' className='width70'></img>
                            </div>

                            <div className="content mt-7">
                                {/* <Link to="/page-services" className="title h5 text-lg font-medium hover:text-indigo-600">CBSE Notes</Link> */}
                                <p className="text-slate-400 mt-3 text-justify mb-5">Stay connected by logging in from multiple devices</p>


                            </div>
                        </div>

                        <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                            <div
                                className="size-16  group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                                {/* <Icons className="size-6"/> */}
                                <img src='images/newfunIcon.jpg' className='width70'></img>
                            </div>

                            <div className="content mt-7">
                                {/* <Link to="/page-services" className="title h5 text-lg font-medium hover:text-indigo-600">CBSE Q’s & A’s</Link> */}
                                <p className="text-slate-400 mt-3 text-justify mb-5">Learning made interactive and visual through engaging video content</p>


                            </div>
                        </div>

                    </div>
                </div>
            </section>}


            <div className='container mt-16'>
                <div className='grid md:grid-cols-12 grid-cols-1 gap-[30px]'>

                    <div className='lg:col-span-4 md:col-span-5'>
                        <ul className="flex-column text-center p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
                            <li onClick={() => setTab('Home')} className='px-4 py-2 text-base font-semibold rounded-md w-full mt-3 hover:text-indigo-600 transition-all duration-500 ease-in-out bg-indigo-600 text-white'>Syllabus</li>
                            <li onClick={() => setTab('About')} className='px-4 py-2 text-base font-semibold rounded-md w-full mt-3 hover:text-indigo-600 transition-all duration-500 ease-in-out'>Study Material</li>
                            <li onClick={() => setTab('Contact')} className='px-4 py-2 text-base font-semibold rounded-md w-full mt-3 hover:text-indigo-600 transition-all duration-500 ease-in-out'>Preparation Time</li>
                        </ul>
                    </div>
                    <div className='lg:col-span-8 md:col-span-5'>
                        <ul className="flex-column p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
                            {tab === 'About' && <div className="mt-6">
                                <h5 className="text-xl  font-bold mb-4">Syllabus</h5>

                                <div className='d-flex align-items-center'>
                                    <img src='images/geogrIcon.jpg'></img>
                                    <h3 className='text-xl text-semibold ms-5'>Geography</h3>
                                </div>

                                <div className='d-flex justify-content-between'>
                                    <ul className='mt-7'>
                                        <li className='d-flex align-items-center ms-1'><span className='mr-3 font-normal text-lg'>1</span> Crop Production and Management</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>2</span> Microorganisms</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>3</span> Synthetic Fibres and Plastics</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>4</span> Materials</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>5</span> Coal and Petroleum</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>6</span> Combustion and Flame</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>7</span> Conservation of Plants and Animals</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>8</span> Cell</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>9</span> Reproduction in Animals</li>
                                    </ul>

                                    <ul className='mt-7'>
                                        <li className='d-flex align-items-center ms-1'><span className='mr-3 font-normal text-lg'>19</span> Crop Production and Management</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>10</span> Microorganisms</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>11</span> Synthetic Fibres and Plastics</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>12</span> Materials</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>13</span> Coal and Petroleum</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>14</span> Combustion and Flame</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>15</span> Conservation of Plants and Animals</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>16</span> Cell</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>17</span> Reproduction in Animals</li>
                                    </ul>
                                </div>

                            </div>}


                            {tab === 'Home' && <div className="mt-6">
                                <h5 className="text-xl  font-bold mb-4">Syllabus</h5>

                                <div className='d-flex align-items-center'>
                                    <img src='images/bioIcon.jpg'></img>
                                    <h3 className='text-xl text-semibold ms-5'>Biology</h3>
                                </div>

                                <div className='d-flex justify-content-between'>
                                    <ul className='mt-7'>
                                        <li className='d-flex align-items-center ms-1'><span className='mr-3 font-normal text-lg'>1</span> Crop Production and Management</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>2</span> Microorganisms</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>3</span> Synthetic Fibres and Plastics</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>4</span> Materials</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>5</span> Coal and Petroleum</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>6</span> Combustion and Flame</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>7</span> Conservation of Plants and Animals</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>8</span> Cell</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>9</span> Reproduction in Animals</li>
                                    </ul>

                                    <ul className='mt-7'>
                                        <li className='d-flex align-items-center ms-1'><span className='mr-3 font-normal text-lg'>10</span> Crop Production and Management</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>11</span> Microorganisms</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>12</span> Synthetic Fibres and Plastics</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>13</span> Materials</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>14</span> Coal and Petroleum</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>15</span> Combustion and Flame</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>16</span> Conservation of Plants and Animals</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>17</span> Cell</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>18</span> Reproduction in Animals</li>
                                    </ul>
                                </div>

                            </div>}

                            {tab === 'About' && <div className="mt-6">
                                <h5 className="text-xl  font-bold mb-4">Syllabus</h5>

                                <div className='d-flex align-items-center'>
                                    <img src='images/geogrIcon.jpg'></img>
                                    <h3 className='text-xl text-semibold ms-5'>Geography</h3>
                                </div>

                                <div className='d-flex justify-content-between'>
                                    <ul className='mt-7'>
                                        <li className='d-flex align-items-center ms-1'><span className='mr-3 font-normal text-lg'>1</span> Crop Production and Management</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>2</span> Microorganisms</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>3</span> Synthetic Fibres and Plastics</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>4</span> Materials</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>5</span> Coal and Petroleum</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>6</span> Combustion and Flame</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>7</span> Conservation of Plants and Animals</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>8</span> Cell</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>9</span> Reproduction in Animals</li>
                                    </ul>

                                    <ul className='mt-7'>
                                        <li className='d-flex align-items-center ms-1'><span className='mr-3 font-normal text-lg'>10</span> Crop Production and Management</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>11</span> Microorganisms</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>12</span> Synthetic Fibres and Plastics</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>13</span> Materials</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>14</span> Coal and Petroleum</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>15</span> Combustion and Flame</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>16</span> Conservation of Plants and Animals</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>17</span> Cell</li>
                                        <li className='d-flex align-items-center '><span className='mr-3 font-normal text-lg'>18</span> Reproduction in Animals</li>
                                    </ul>
                                </div>

                            </div>}


                            {tab === 'Contact' && <div className="mt-6">
                                <h5 className="text-xl  font-bold mb-4">Syllabus</h5>

                                <div className='d-flex align-items-center'>
                                    <img src='images/bioIcon.jpg'></img>
                                    <h3 className='text-xl text-semibold ms-5'>Preparation Time
                                    </h3>
                                </div>



                            </div>}

                        </ul>
                    </div>
                </div>
            </div>



            <section className='py-9 bg-indigo-600 mt-6'>
                <div className='container'>
                    <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
                        <div>
                            <h1 className='heading text-white'>Start your learning Journey !</h1>
                            <div className='mt-7'>
                                <a href="" data-discover="true"><img class="inline-block width40" alt="" src="images/Tutormate-GooglePlaystore.png" /></a>
                                <a href="" data-discover="true"><img class="inline-block width40 ms-2" alt="" src="images/Tutormate-AppleStore.png" /></a>
                            </div>
                        </div>

                        <div className='d-flex justify-end'>
                            <div className="lg:col-span-6">
                                <h1 className='h5 titile text-white text-md'>Get SMS link to download the app</h1>

                                <span className='d-flex'>
                                    <input className='form-input mt-3  py-2 px-3 h-10   dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0' placeholder='Enter Phone Number'></input>
                                    <div className="lg:col-span-6">
                                        <Link to="" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-white text-indigo-600 rounded-md me-1 mt-3 ms-3">Get Link</Link>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


                <div className="container relative mt-16 pb-16">
                            <div className="grid grid-cols-1 pb-8 text-center">
                                <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">FAQ’s</h3>

                                {/* <p className="text-slate-400 max-w-xl mx-auto">Start working with Techwind that can provide everything you need to generate awareness, drive traffic, connect.</p> */}
                            </div>
                          <div className="grid md:grid-cols-2 grid-cols-1 gap-[30px]">
                            <div className="flex">
                              <div className="flex-1">
                                <h5 className="mb-2 text-xl font-bold">1. Does the content cover the entire high school syllabus?</h5>
                                <p className="text-slate-400">A. Yes, our content is exhaustive and in accordance with the NCERT textbooks according to the CBSE curriculum</p>
                              </div>
                            </div>
                
                            <div className="flex">
                              <div className="flex-1">
                                <h5 className="mb-2 text-xl font-bold">2. Are the notes provided the same as the content of the textbooks?</h5>
                                <p className="text-slate-400">A. The notes are a simplified and easy-to-understand version of the textbooks. Our notes will help you review and understand the core concepts of every chapter.</p>
                              </div>
                            </div>
                
                            <div className="flex">
                              <div className="flex-1">
                                <h5 className="mb-2 text-xl font-bold"> 3. How are the practice questions evaluated?</h5>
                                <p className="text-slate-400">A. Our practice questions are all-encompassing and each of them comes with solutions for you to evaluate yourself before an exam. The questions aren’t restricted to just multiple choice questions but provide solutions to all long and short format questions</p>
                              </div>
                            </div>
                
                            <div className="flex">
                              <div className="flex-1">
                                <h5 className="mb-2 text-xl font-bold"> 4. Is the App free?</h5>
                                <p className="text-slate-400">A. The app provides a free trial after which users can go for a paid subscription. </p>
                              </div>
                            </div>

                            <div className="flex">
                              <div className="flex-1">
                                <h5 className="mb-2 text-xl font-bold"> 5. Can the App be accessed from Mobile?</h5>
                                <p className="text-slate-400">A. Yes, you can log into your account by signing in from multiple devices – including mobile, tablet as well as website version, for easy access – thereby ensuring you’re always connected</p>
                              </div>
                            </div>

                            <div className="flex">
                              <div className="flex-1">
                                <h5 className="mb-2 text-xl font-bold">6. Can students just stick to the content here, and nothing else?</h5>
                                <p className="text-slate-400">A. Absolutely. Our content is designed to help students understand the content thoroughly and is a one-stop-shop solution for all your examination needs.</p>
                              </div>
                            </div>
                          </div>
                        </div>
            <Footer />

        </>
    )
}
